import { makeStyles } from '@material-ui/styles';
// import tinycolor from 'tinycolor2';

export default makeStyles(theme => ({

    /* Background */
    st0: (props) => {
        const {
            backgroundColor,
        } = props;

        return {
            fill: backgroundColor || '#1CB1F9',
        };
    },

    /* font color */
    st12: (props) => {
        const {
            fontColor,
        } = props;

        return {
            fill: fontColor || '#FFFFFF',
        };
    },

    st1: (props) => {
        const {
            backgroundColor,
        } = props;

        return {
            fill: backgroundColor || '#1CB1F9',
            filter: 'brightness(0.85)',
        };
    },

    st2: {
        fill: '#FFFFFF',
    },

    st11: {
        fill: 'none',
    },

    st13: {
    },

    st14: {
        fontSize: '16px',
        fontWeight: '500',
    },

}));
